import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextTooltipModule } from '@lib/components';
import { TooltipDirectiveModule } from '@lib/directives';
import { StaticMsgModule } from '@lib/pipes';
import { SeatAttributeRequestSubHeaderComponent } from './seat-attribute-request-sub-header.component';

@NgModule({
  declarations: [SeatAttributeRequestSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, TextTooltipModule, TooltipDirectiveModule],
  exports: [SeatAttributeRequestSubHeaderComponent],
})
export class SeatAttributeRequestSubHeaderModule {}
